<template>
	<div :class="classes">
		<FontAwesomeIcon
			class="back-button"
			:icon="[ `fas`, `arrow-left`]"
			@click="$emit( `back` )"
		/>
	</div>
</template>

<script>

export default {
	name: "BackButton",
	emits: [ "back", ],
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "MEDIUM",
		},
	},
	computed: {
		classes() {
			return {
				"back-button-box": true,
				"back-button-box--small": ( this.size === "SMALL" ),
				"back-button-box--disabled": this.disabled,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$backButtonColor: $color2-500;
$backButtonColor--disabled: $color1-500;
$backButtonBorderColor: $color2-100;
$backButtonBorderColor--disabled: $color1-100;
$backButtonBorderColor--hover: $color2-200;
$backButtonBackgroundColor--hover: $color2-100;

.back-button-box {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	border: 0.125rem solid $backButtonBorderColor;
	border-radius: 0.5rem;
	padding: 0.5rem;

	cursor: pointer;

	&:not(.back-button-box--disabled):hover {
		background-color: $backButtonBackgroundColor--hover;
		border-color: $backButtonBorderColor--hover;
	}
}

.back-button {
	font-size: 1rem;
	color: $backButtonColor;
}

.back-button-box--small {
	padding: 0.4rem;

	.back-button {
		font-size: 0.8rem;
		font-weight: 600;
	}
}

.back-button-box--disabled {
	border-color: $backButtonBorderColor--disabled;
	cursor: not-allowed;

	.back-button {
		color: $backButtonColor--disabled;
	}
}
</style>
